import { APIClient } from "helpers/api_helper";

const api = new APIClient();

export async function getDashboard({ id }) {
  try {
    const response = await api.get(
      `/merchant/dashboard/summary?merchantId=${id}`
    );
    return response.data; // Assuming the API returns data in a field called `data`
  } catch (error) {
    console.error(error);
    throw new Error("Dashboard could not be loaded");
  }
}

export async function getRevenue({ id }) {
  try {
    const response = await api.get(
      `/merchant/dashboard/revenue-overview?merchantId=${id}`
    );
    return response;
  } catch (error) {
    console.error(error);
    throw new Error("Revenue could not be loaded");
  }
}
